import { SamIcon } from '@/components/shared/SamIcon';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

const MESSAGES = [
  'Generating your campaign, do not refresh the page...',
  'Why not grab a cup of coffee while you wait?...',
  "There's a lot to analyse and it will take me a moment to pull it all together...",
];

export const AiLoader = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % MESSAGES.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="w-40 h-40 flex">
        <SamIcon animate={true} />
      </div>
      <motion.p
        key={currentMessageIndex}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        className="text-center">
        {MESSAGES[currentMessageIndex]}
      </motion.p>
    </div>
  );
};
